import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	companies: {
		data: [],
		error: null,
		loading: false,
		totalCount: 0,
		tableParams: {
			page: 0,
			size: 10,
		},
	},
	company: { data: null, error: null, loading: false },
	editedCompany: { data: null, error: null, loading: false },
	removedCompany: { data: null, error: null, loading: false },
	createdCompany: { data: null, error: null, loading: false },
};

const { actions, reducer } = createSlice({
	name: 'companies',
	initialState,
	reducers: {
		getCompanies: (state, { payload }) => {
			const { saveConfig = true, ...restPayload } = payload;
			state.companies = {
				...state.companies,
				...(saveConfig ? { tableParams: restPayload } : {}),
				error: null,
				loading: true,
			};
		},
		getCompaniesFailure: (state, { payload }) => {
			state.companies = {
				...state.companies,
				error: payload,
				loading: false,
			};
		},
		getCompaniesSuccess: (state, { payload }) => {
			state.companies = {
				...state.companies,
				data: payload.body,
				totalCount: payload.meta.totalCount,
				error: null,
				loading: false,
			};
		},
		getCompanyById: (state, { payload }) => {
			state.company = {
				...state.company,
				error: null,
				loading: true,
			};
		},
		getCompanyByIdFailure: (state, { payload }) => {
			state.company = {
				...state.company,
				error: payload,
				loading: false,
			};
		},
		getCompanyByIdSuccess: (state, { payload }) => {
			state.company = {
				...state.company,
				data: payload,
				error: null,
				loading: false,
			};
		},
		createCompany: (state, { payload }) => {
			state.createdCompany = {
				...state.createdCompany,
				error: null,
				loading: true,
			};
		},
		createCompanyFailure: (state, { payload }) => {
			state.createdCompany = {
				...state.createdCompany,
				error: payload,
				loading: false,
			};
		},
		createCompanySuccess: (state, { payload }) => {
			state.createdCompany = {
				...state.createdCompany,
				data: payload,
				error: null,
				loading: false,
			};
		},
		updateCompany: (state, { payload }) => {
			state.editedCompany = {
				...state.editedCompany,
				error: null,
				loading: true,
			};
		},
		updateCompanyFailure: (state, { payload }) => {
			state.editedCompany = {
				...state.editedCompany,
				error: payload,
				loading: false,
			};
		},
		updateCompanySuccess: (state, { payload }) => {
			state.editedCompany = {
				...state.editedCompany,
				data: payload,
				error: null,
				loading: false,
			};
		},
		removeCompany: (state, { payload }) => {
			state.removedCompany = {
				...state.removedCompany,
				error: null,
				loading: true,
			};
		},
		removeCompanyFailure: (state, { payload }) => {
			state.removedCompany = {
				...state.removedCompany,
				error: payload,
				loading: false,
			};
		},
		removeCompanySuccess: (state, { payload }) => {
			state.removedCompany = {
				...state.removedCompany,
				data: payload,
				error: null,
				loading: false,
			};
		},
	},
});

export const {
	getCompanies,
	getCompaniesFailure,
	getCompaniesSuccess,
	getCompanyById,
	getCompanyByIdFailure,
	getCompanyByIdSuccess,
	createCompany,
	createCompanyFailure,
	createCompanySuccess,
	updateCompany,
	updateCompanyFailure,
	updateCompanySuccess,
	removeCompany,
	removeCompanyFailure,
	removeCompanySuccess,
} = actions;

export { default as companiesSaga } from './sagas';

export default reducer;
